import { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useProductForm = () => {
  const location = useLocation();
  const { transactionId } = useParams();
  const [isBarcodeFromScan, setIsBarcodeFromScan] = useState(false);
  const [errors, setErrors] = useState({});

  const initialFormData = {
    is_new_transaction: true,
    company_id: '',
    category_id: '',
    brand_name: '',
    brand_id: '',
    product_name: '',
    product_images: [],
    description: '',
    storage_type: '',
    warehouse_id: '',
    expire_date: '',
    barcode_number: '',
    status: '1',
    e_commerce_platform: 'lazada',
    productType: 'non-perishable',
    quantity: 0
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (location.state?.barcode) {
      setFormData(prev => ({
        ...prev,
        barcode_number: location.state.barcode
      }));

      if (location.state?.autoRedirected) {
        setIsBarcodeFromScan(true);
      }
    }
  }, [location.state]);

  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear error for this field when user starts typing/selecting
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: ''
      }));
    }
  };

  const clearAttributeError = (attributeName) => {
    const errorKey = `attribute_${attributeName}`;
    if (errors[errorKey]) {
      setErrors(prev => ({
        ...prev,
        [errorKey]: ''
      }));
    }
  };

  const enableManualBarcodeEdit = () => {
    setIsBarcodeFromScan(false);
    updateFormData('barcode_number', '');
  };

  return {
    formData,
    setFormData,
    updateFormData,
    errors,
    setErrors,
    clearError,
    clearAttributeError,
    isBarcodeFromScan,
    setIsBarcodeFromScan,
    enableManualBarcodeEdit,
    transactionId
  };
};